import React from 'react';
import {
  CompressorIcon,
  DefrostEnableIcon,
  TurnOnOffIcon,
} from '../../../theme/icons';

export const getIcon = (channelType: string) => {
  switch (channelType) {
    case 'On':
      return <TurnOnOffIcon fontSize={'1.5rem'} />;
    case 'Compressor':
      return <CompressorIcon fontSize={'1.5rem'} />;
    case 'Defrost':
      return <DefrostEnableIcon fontSize={'1.5rem'} />;
    default:
      return null;
  }
};
